import React from 'react';
import Loading, { LoadingBall } from '@ingka/loading';

export interface LoaderProps {
  text?: string;
}

const Loader = ({ text }: LoaderProps): JSX.Element => {
  return (
    <Loading text={text || ''}>
      <LoadingBall />
    </Loading>
  );
};

export default Loader;
